import { createGlobalStyle } from 'styled-components';

import toastify from '../../../../../node_modules/react-toastify/dist/ReactToastify.min.css';

export const Styles = createGlobalStyle`
  ${toastify};
`;
